export default "__VITE_ASSET__d253fa26__"